import * as React from 'react'

const SvgCalendarIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.25 2.519h-2.5v-1.25H12.5v1.25h-5v-1.25H6.25v1.25h-2.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-12.5c0-.69-.56-1.25-1.25-1.25zm0 13.75H3.75v-8.75h12.5v8.75zm0-10H3.75v-2.5h2.5v1.25H7.5v-1.25h5v1.25h1.25v-1.25h2.5v2.5z"
      fill="#163250"
    />
  </svg>
)

export default SvgCalendarIcon
